export default __webpack_public_path__ + "static/media/portfolio-171.f719bf6c.jpg";